export default __webpack_public_path__ + "static/media/img_introduce_ai_2.70c545fc.png";